import {config} from '../config';

export default {
    getConnectivityIsBle: () => config.data.connectivity.isBle,
    getConnectivityIsUsb: () => config.data.connectivity.isUsb,
};
